export const 
	// API_URL = 'http://localhost/volleyball/api';
	// API_URL = 'http://ovz1.id3179000.pk7kn.vps.myjino.ru/api';
	API_URL = 'https://liga4plus2.ru/api';


// WEBPACK FOOTER //
// ./src/api/Endpoints.js